// Gate для запроса РСЯ: слот запрашивает рекламу только если
// (1) он реально в вьюпорте и (2) blockId ещё никто не запросил на странице.
// Защищает от холостых hits (показы/запросы падают в статистике РСЯ).

export interface AdGateInput {
  visible: boolean;
  liveBlockIds: Set<string>;
  blockId: string;
}

export function shouldRequestAd({ visible, liveBlockIds, blockId }: AdGateInput): boolean {
  return visible && !!blockId && !liveBlockIds.has(blockId);
}

// ponytail: self-check вместо фреймворка — esbuild + node, пока не появится vitest
export function _selfCheck(): void {
  const live = new Set<string>();
  const a = shouldRequestAd({ visible: true, liveBlockIds: live, blockId: 'R-A-1' });
  live.add('R-A-1');
  const b = shouldRequestAd({ visible: false, liveBlockIds: live, blockId: 'R-A-1' });
  const c = shouldRequestAd({ visible: true, liveBlockIds: live, blockId: 'R-A-1' });
  const d = shouldRequestAd({ visible: true, liveBlockIds: live, blockId: 'R-A-2' });
  const ok = a === true && b === false && c === false && d === true;
  if (!ok) {
    throw new Error(`shouldRequestAd self-check failed: ${a} ${b} ${c} ${d}`);
  }
  console.log('shouldRequestAd self-check OK');
}
